import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactViewModalComponent } from 'src/app/shared/modals/contact-view-modal/contact-view-modal.component';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styles: [],
})
export class ContactComponent implements OnInit {
    constructor(private activatedRoute: ActivatedRoute, private modalService: NgbModal) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    viewContact(item: any) {
        let contactModal = this.modalService.open(ContactViewModalComponent, { windowClass: 'contact-modal' });
        contactModal.componentInstance.contact = item;
    }
}
